var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "motoboy-section mb-2" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-between mb-1",
        },
        [
          _c(
            "h2",
            { staticClass: "h3 mb-0" },
            [
              _vm._v(" " + _vm._s(_vm.$t("Motoboys")) + " "),
              _c("b-badge", { attrs: { variant: "primary" } }, [
                _vm._v(" " + _vm._s(_vm.workingMotoboys.length) + " "),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c("small", { staticClass: "text-muted mr-1" }, [
                _vm._v(_vm._s(_vm.$t("Presença e composição de entregas"))),
              ]),
              _c("e-button", {
                attrs: {
                  id: "motoboy-section_add-presence",
                  size: "sm",
                  icon: "person-plus",
                  text: _vm.$t("Adicionar presença"),
                  disabled: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    _vm.showPresenceSidebar = true
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.loading
        ? _c("div", { staticClass: "py-2" }, [_c("e-spinner")], 1)
        : !_vm.workingMotoboys.length
        ? _c(
            "b-alert",
            { staticClass: "mb-0", attrs: { show: "", variant: "light" } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.motoboys.length
                      ? _vm.$t("Nenhum Motoboy presente no momento")
                      : _vm.$t("Não há Motoboys vinculados a esta loja")
                  ) +
                  " "
              ),
            ]
          )
        : _c(
            "div",
            { staticClass: "motoboy-section__list" },
            _vm._l(_vm.workingMotoboys, function (motoboy) {
              return _c(
                "b-card",
                {
                  key: _vm.motoboyId(motoboy),
                  staticClass: "motoboy-card mb-0",
                  class:
                    "motoboy-card--" + _vm.presenceState(motoboy).toLowerCase(),
                  attrs: { "no-body": "" },
                },
                [
                  _c("div", { staticClass: "p-1" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.motoboyName(motoboy))),
                        ]),
                        _c(
                          "b-badge",
                          { attrs: { variant: _vm.presenceVariant(motoboy) } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.presenceLabel(motoboy)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mt-1" },
                      [
                        _c("small", { staticClass: "font-weight-bold" }, [
                          _vm._v(_vm._s(_vm.$t("Pedidos")) + ":"),
                        ]),
                        !_vm.assignedOrders(motoboy).length
                          ? _c("span", { staticClass: "text-muted ml-50" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Nenhum pedido atribuído")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._l(_vm.assignedOrders(motoboy), function (order) {
                          return _c(
                            "b-badge",
                            {
                              key: _vm.orderId(order),
                              staticClass: "ml-50",
                              attrs: { variant: "light-primary" },
                            },
                            [_vm._v(" #" + _vm._s(_vm.orderId(order)) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex mt-1" },
                      [
                        _vm.presenceState(motoboy) === "Present"
                          ? [
                              _c("e-button", {
                                attrs: {
                                  size: "sm",
                                  variant: "outline-secondary",
                                  icon: "person-x",
                                  busy: _vm.isPending(motoboy),
                                  text: _vm.$t("Marcar ausente"),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changePresence(motoboy, "Absent")
                                  },
                                },
                              }),
                              _vm.assignedOrders(motoboy).length
                                ? _c("e-button", {
                                    staticClass: "ml-50",
                                    attrs: {
                                      size: "sm",
                                      icon: "truck",
                                      busy: _vm.isPending(motoboy),
                                      text: _vm.$t("Iniciar entrega"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startDelivery(motoboy)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          : _vm.hasDeliveryInRoute(motoboy)
                          ? _c("e-button", {
                              attrs: {
                                size: "sm",
                                icon: "plus-circle",
                                text: _vm.$t("Adicionar pedido"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openAddOrder(motoboy)
                                },
                              },
                            })
                          : _c("e-button", {
                              attrs: {
                                size: "sm",
                                icon: "person-check",
                                busy: _vm.isPending(motoboy),
                                text: _vm.$t("Liberar"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changePresence(motoboy, "Present")
                                },
                              },
                            }),
                      ],
                      2
                    ),
                  ]),
                ]
              )
            }),
            1
          ),
      _c("motoboy-presence-sidebar", {
        attrs: { show: _vm.showPresenceSidebar },
        on: {
          hidden: function ($event) {
            _vm.showPresenceSidebar = false
          },
        },
      }),
      _c("motoboy-add-order-sidebar", {
        attrs: { show: !!_vm.addOrderMotoboy, motoboy: _vm.addOrderMotoboy },
        on: {
          hidden: function ($event) {
            _vm.addOrderMotoboy = null
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }